module.exports = __webpack_public_path__ + "img/aside-image.047a4954.webp";